import { render } from "./CustomRadio.vue?vue&type=template&id=0f4cd412&scoped=true"
import script from "./CustomRadio.vue?vue&type=script&lang=js"
export * from "./CustomRadio.vue?vue&type=script&lang=js"

import "./CustomRadio.vue?vue&type=style&index=0&id=0f4cd412&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4cd412"]])

export default __exports__